import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Searchbar, ContributionSearchLabel, SpaceBetween, ContributionSearchContainer } from './styles';
import MultiSelect from "../Select";
import TimeFrameComponent from "../TimeFrameComponent";
import { connect } from 'react-redux';
import { updateFilterData } from '../../actions';
import moment from "moment";
import { contributionSearchMobileState } from "../../selectors";

export class ContributionSearchMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: null,
      dates: null,
      status: null,
      visible: false
    };
    this.filterBasedOnDates = this.filterBasedOnDates.bind(this);
  }

  filterBasedOnDates(dates){
    let mainData = this.props.contributionData;
    if(this.props.statusFilterData){
      mainData = this.props.statusFilterData;
    }
    if(dates.length >1){  
    if (dates.length > 0){
      let filteredData = [];
      if (mainData !== undefined)
      {
        let updatedData = mainData;
        if (dates)
        {
          const date1 = moment(dates[0],"MM/DD/YYYY");
          const date2 = moment(dates[1],"MM/DD/YYYY");
          filteredData = updatedData.filter(x => {
            let isValid = false;
            if(x.enteredDate !== "--"){
              if(moment(x.enteredDate, "MM/DD/YYYY") >= date1 && moment(x.enteredDate <= date2)){
                isValid = true;
              }else{
                isValid = false;
              }
              return isValid;
            }
          }
          );
        }
        this.props.updateFilterData({filteredData, mode:"timeFrameData",data: filteredData, dates: dates });
      }
      this.setState({visible: false})
    }else{
      this.props.updateFilterData({filteredData : mainData, mode:"timeFrameData",data: null, dates: null});
    }
  }else{
    this.setState({visible: false, dates:[]})
    this.props.updateFilterData({filteredData: mainData, mode:"timeFrameData",data: null, dates: null});
  } 
}
 
  render() {
    const options = this.props.dropDownValues ? this.props.dropDownValues : [];

    return (
      <ContributionSearchContainer>
        <Searchbar>
          <SpaceBetween>
          <ContributionSearchLabel>Status</ContributionSearchLabel>          
              <MultiSelect options={options} handleDropper={this.props.handleDropper} menu={this.props.menu}/>
              </SpaceBetween>
          <SpaceBetween style={{marginTop: '20px'}}>
          <ContributionSearchLabel>Time Frame</ContributionSearchLabel>
          <TimeFrameComponent
            style={{ "width": "68%" }}
            visible={this.state.visible}
            onFilterClick={(dates) => this.filterBasedOnDates(dates)}
          >
            Select TimeFrame
          </TimeFrameComponent>
          </SpaceBetween>
          <div style={{ width: "35px" }} />
        </Searchbar>
      </ContributionSearchContainer>
    );
  }
}

ContributionSearchMobile.propTypes = {
  contributionData: PropTypes.array,
  dropDownValues: PropTypes.array,
  statusFilterData: PropTypes.array,
  timeFrameData: PropTypes.array,
  updateFilterData: PropTypes.func
}


const mapStateToProps = (state) =>({
    ...contributionSearchMobileState(state.toJS())
  });
  
  export const mapDispatchToProps = (dispatch) =>({
    updateFilterData: data => dispatch(updateFilterData(data)),
  });
  
  export default connect(mapStateToProps,mapDispatchToProps)(ContributionSearchMobile);
 